import React, { Fragment, useEffect, useState } from 'react'
import Navbar from '../../components/Navbar'
import { Dialog, Transition } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { ToastContainer } from 'react-toastify';
// import { useLoaderData } from 'react-router-dom';
// import areca from '../../assets/plants/areca-palm-plant.webp'
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}

const columns = [
    'ID',
    'NAME',
    'DESCRIPTION',
    'COST PER ITEM',
    'QUANTIY',
    'STATUS',
    'DISCOUNT',
    'TYPE',
    'EDIT'
]

const TYPE = [
    'Plants',
    'Seeds',
    'Planters',
    'Tools',
    'Flowering Plants',
]

const STATUS = [
    'Active',
    'Inactive',
    'Offline'
]


const Inventory = () => {
    const [view, setView] = useState(false)
    const [productName, setProductName] = useState('')
    const [description, setDescription] = useState('')
    const [cost, setCost] = useState(0)
    const [quantity, setQuantity] = useState('')
    const [status, setStatus] = useState(STATUS[0])
    const [discount, setDiscount] = useState('')
    const [type, setType] = useState(TYPE[0])
    const [imgSrc, setImgSrc] = useState('')
    const [featureFirst, setFeatureFirst] = useState('')
    const [featureSecond, setFeatureSecond] = useState('')
    const [featureThird, setFeatureThird] = useState('')
    const [featureFourth, setFeatureFourth] = useState('')
    const [value, setValue] = useState('')
    const [isLoading, setIsLoading] = useState(false)
    const [ProductData, setProductData] = useState([])
    const [allProductData, setAllProductData] = useState([]);
    const [isEdit, setIsEdit] = useState(false)
    const [uid, setUid] = useState('')
    const [search , setSearch] = useState("");


    const getBase64 = (file) => {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            setImgSrc(reader.result)
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    }


    const notify = (text) => toast(text, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
    });

    const resetStates = () => {
        setProductName('')
        setDescription('')
        setCost(0)
        setQuantity('')
        setStatus(STATUS[0])
        setDiscount('')
        setType(TYPE[0])
        setImgSrc('')
        setFeatureFirst('')
        setFeatureSecond('')
        setFeatureThird('')
        setFeatureFourth('')
        setValue('')
    }

    const validate = () => {
        if (productName === '' || description === '' || cost === 0 || quantity === '' || status === '' || discount === '' || type === '' || imgSrc === '' || featureFirst === '' || featureSecond === '' || featureThird === '' || featureFourth === '') {
            notify('Please fill all the fields')
            return false
        }
        if (isNaN(cost) || isNaN(quantity) || isNaN(discount)) {
            notify('Please enter valid data')
            return false
        }
        if (cost < 0 || quantity < 0 || discount < 0) {
            notify('Please enter valid data')
            return false
        }
        if (discount > 100) {
            notify('Discount cannot be greater than 100')
            return false
        }
        return true
    }

    const handleSubmit = () => {
        // e.preventDeafult()

        var obj = {};
        obj.uid = uid;
        obj.isEdit = isEdit;
        obj.id = 'GG123456';
        obj.name = productName;
        obj.description = description;
        obj.cost_per_unit = cost;
        obj.quantity = quantity;
        obj.status = status;
        obj.discount = Math.floor(discount * 0.01 * cost);
        obj.type = type;
        obj.imgUrl = imgSrc;
        obj.features = [{ name: 'Plant Type', description: featureFirst }, { name: 'Soil Type', description: featureSecond }, { name: 'Mature Size', description: featureThird }, { name: 'Family', description: featureFourth }]
        // ProductData.push(obj)
        console.log(obj)
        setView(false)

        if (validate())
            try {
                fetch(process.env.REACT_APP_SERVER_URL + '/inventory/addProduct', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + localStorage.getItem('token')
                    },
                    body: JSON.stringify(obj)
                })
                    .then(res => res.json())
                    .then(data => {
                        console.log(data)
                        loadData()
                        resetStates()
                    }
                    ).catch(err => console.log(err))
            } catch (error) {
                console.log(error)
            }
    }

    const deleteProduct = (id) => {
        try {
            fetch(process.env.REACT_APP_SERVER_URL + `/inventory/deleteProduct`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`

                },
                body: JSON.stringify({ id })
            })
                .then(res => res.json())
                .then(data => {
                    console.log(data)
                    loadData()
                }
                ).catch(err => console.log(err))
        } catch (error) {
            console.log(error)
        }
    }

    const handleEdit = (item, id) => {
        setProductName(item.name)
        setDescription(item.description)
        setCost(item.cost_per_unit)
        setQuantity(item.quantity)
        setStatus(item.status)
        setDiscount(Math.floor(item.discount*100/item.cost_per_unit))
        setType(item.type)
        setImgSrc(item.imgUrl)
        setFeatureFirst(item.features[0].description)
        setFeatureSecond(item.features[1].description)
        setFeatureThird(item.features[2].description)
        setFeatureFourth(item.features[3].description)
        setUid(id)
    }

    const loadData = async () => {
        try {
            fetch(process.env.REACT_APP_SERVER_URL + '/inventory/getAllProductbySeller', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + localStorage.getItem('token')
                }
            })
                .then(res => res.json())
                .then(data => {
                    if (data.success) {
                        setIsLoading(true)
                    }
                    console.log(data)
                    setProductData(data.allProductbySeller)
                    console.log(data.product)
                }
                ).catch(err => console.log(err))
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        setAllProductData(ProductData);
      if (search !== "") {
        let filteredBuyers = ProductData.filter((item) =>
          item.name.toLowerCase().includes(search.toLowerCase())
        );
        setAllProductData(filteredBuyers);
      } else {
        setAllProductData(ProductData);
      }
    //   loadData();
    }, [search, ProductData]);

    useEffect(() => {
        loadData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <div className='bg-[#F8FBF8] font-poppins'>
            <Navbar />
            <div>
                <ToastContainer className='mt-20' />
            </div>
            <div className="min-h-screen text-gray-900 mx-2 lg:mx-10 mt-12">
                <main className=" mx-auto  sm:px-6 lg:px-8 pt-4">
                    <div className="">
                        <h1 className="text-2xl ">Products List</h1>
                    </div>
                    <div className='mt-10 flex-col md:flex-row space-y-5 justify-between items-center'>
                        <label className="flex flex-col md:flex-row gap-2 items-baseline">
                            <span className="text-gray-700">Search: </span>
                            <input
                                type="text"
                                className="rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                                value={value || ""}
                                onChange={e => {
                                    setValue(e.target.value);
                                    setSearch(e.target.value);
                                }}
                                placeholder={`${ProductData?.length} records...`}
                            />
                        </label>
                        <div>
                            <button onClick={() => { setView(true); setIsEdit(false) }} type="button" className="text-white bg-gradient-to-r from-cyan-500 to-blue-500 hover:bg-gradient-to-bl  dark:focus:ring-cyan-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-2 mb-2">Add Product</button>
                            <button onClick={() => { loadData() }} type="button" className="text-white bg-gradient-to-r from-green-400 to-green-500 hover:bg-gradient-to-bl  dark:focus:ring-green-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-2 mb-2">Refresh</button>
                        </div>
                    </div>
                    <div className="mt-4 flex flex-col mx-2 lg:mx-0">
                        <div className="-my-2 overflow-x-auto -mx-4 sm:-mx-6 lg:-mx-8">
                            <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                                <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg mx-2">
                                    <table className="table-auto min-w-full divide-y divide-gray-200">
                                        <thead className='bg-gray-50'>
                                            <tr>
                                                {columns.map((item, key) => (
                                                    <th key={key}
                                                        scope="col"
                                                        className="group px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">{item}</th>
                                                ))}
                                            </tr>
                                        </thead>
                                        <tbody className="bg-white divide-y divide-gray-200">
                                            {
                                                isLoading && allProductData.length > 0 && allProductData.map(item => (
                                                    <tr key={item._id} className="text-sm">
                                                        <td className="px-2 py-4 whitespace-nowrap truncate" role="cell">{item._id}</td>
                                                        <td className="px-6 py-4 whitespace-nowrap" role="cell">
                                                            <div className='flex items-center gap-2'>
                                                                <div className="h-10 w-10">
                                                                    <img className="h-10 w-10 rounded-full" src={item.imgUrl} alt="" />

                                                                </div>
                                                                <div>{item.name}</div>

                                                            </div>
                                                        </td>
                                                        <td className="px-6 py-4 " role="cell">
                                                            <p className='w-40 truncate '> {item.description}</p>
                                                        </td>
                                                        <td className="px-6 py-4 whitespace-nowrap" role="cell">₹ {item.cost_per_unit}</td>
                                                        <td className="px-6 py-4 whitespace-nowrap" role="cell">{item.quantity}</td>
                                                        <td className="px-6 py-4 whitespace-nowrap" role="cell">
                                                            <span className={
                                                                classNames(
                                                                    "px-3 py-1 uppercase leading-wide font-bold text-xs rounded-full shadow-sm",
                                                                    item.status.startsWith("Active") ? "bg-green-100 text-green-800" : null,
                                                                    item.status.startsWith("Inactive") ? "bg-yellow-100 text-yellow-800" : null,
                                                                    item.status.startsWith("Offline") ? "bg-red-100 text-red-800" : null,
                                                                )
                                                            }>{item.status}</span>
                                                        </td>
                                                        <td className="px-6 py-4 whitespace-nowrap" role="cell">₹ {Math.floor(item.discount)}</td>
                                                        <td className="px-6 py-4 whitespace-nowrap" role="cell">{item.type}</td>
                                                        <td className="px-6 py-4 whitespace-nowrap" role="cell">
                                                            <div className='gap-2'>
                                                                <button className="relative inline-flex items-center justify-center p-0.5 mb-2 mr-2 overflow-hidden text-sm font-medium text-gray-900 rounded-lg group bg-gradient-to-br from-red-200 via-red-300 to-yellow-200 group-hover:from-red-200 group-hover:via-red-300 group-hover:to-yellow-200 dark:text-white dark:hover:text-gray-900 focus:ring-4 focus:outline-none focus:ring-red-100 dark:focus:ring-red-400"
                                                                    onClick={() => { setView(true); setIsEdit(true); handleEdit(item, item._id) }}
                                                                >
                                                                    <span className="relative px-5 py-2.5 transition-all ease-in duration-75 bg-white dark:bg-gray-900 rounded-md group-hover:bg-opacity-0">
                                                                        Edit
                                                                    </span>
                                                                </button>
                                                                <button className="relative inline-flex items-center justify-center p-0.5 mb-2 mr-2 overflow-hidden text-sm font-medium text-gray-900 rounded-lg group bg-gradient-to-br from-pink-500 to-orange-400 group-hover:from-pink-500 group-hover:to-orange-400 hover:text-white dark:text-white focus:ring-4 focus:outline-none focus:ring-pink-200 dark:focus:ring-pink-800" onClick={
                                                                    () => {
                                                                        deleteProduct(item._id)
                                                                    }
                                                                }>
                                                                    <span className="relative px-5 py-2.5 transition-all ease-in duration-75 bg-white dark:bg-gray-900 rounded-md group-hover:bg-opacity-0">
                                                                        Delete
                                                                    </span>
                                                                </button>

                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))
                                            }

                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
            </div>

            <Transition.Root show={view} as={Fragment}>
                <Dialog as="div" className="relative z-10" onClose={() => setView(false)}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 hidden bg-gray-500 bg-opacity-75 transition-opacity md:block" />
                    </Transition.Child>

                    <div className="fixed inset-0 z-10 overflow-y-auto">
                        <div className="flex min-h-full items-stretch justify-center text-center md:items-center md:px-2 lg:px-4">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 translate-y-4 md:translate-y-0 md:scale-95"
                                enterTo="opacity-100 translate-y-0 md:scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 translate-y-0 md:scale-100"
                                leaveTo="opacity-0 translate-y-4 md:translate-y-0 md:scale-95"
                            >
                                <Dialog.Panel className="flex w-full transform text-left text-base transition md:my-8 md:max-w-2xl md:px-4 lg:max-w-4xl">
                                    <div className="relative flex w-full items-center overflow-hidden bg-white px-4 pt-14 pb-8 shadow-2xl sm:px-6 sm:pt-8 md:p-6 lg:p-8">
                                        <button
                                            type="button"
                                            className="absolute top-4 right-4 text-gray-400 hover:text-gray-500 sm:top-8 sm:right-6 md:top-6 md:right-6 lg:top-8 lg:right-8"
                                            onClick={() => { setView(false); resetStates() }}
                                        >
                                            <span className="sr-only">Close</span>
                                            <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                                        </button>


                                        <div className="grid w-full grid-cols-1 items-start gap-y-8 gap-x-6 sm:grid-cols-12 lg:gap-x-8">
                                            <div className="aspect-w-2 aspect-h-3 rounded-lg bg-gray-100 sm:col-span-4 lg:col-span-5">
                                                {imgSrc.length > 0 ? <img onDoubleClick={(e) => { e.preventDefault(); setImgSrc('') }} src={imgSrc} alt="..." defaultValue={imgSrc} className='object-cover hover:opacity-30 cursor-pointer' /> :
                                                    <div className="flex justify-center items-center w-full">
                                                        <label htmlFor="dropzone-file" className="flex flex-col justify-center items-center w-full h-full bg-gray-50 rounded-lg border-2 border-gray-300 border-dashed cursor-pointer dark:hover:bg-bray-800 dark:bg-gray-700 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600">
                                                            <div className="flex flex-col justify-center items-center pt-5 pb-6">
                                                                <svg aria-hidden="true" className="mb-3 w-10 h-10 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"></path></svg>
                                                                <p className="mb-2 text-sm text-gray-500 dark:text-gray-400"><span className="font-semibold">Click to upload</span> </p>
                                                                <p className="text-xs text-gray-500 dark:text-gray-400">SVG, PNG, JPG or GIF (MAX. 800x400px)</p>
                                                            </div>
                                                            <input onChange={(e) => {
                                                                var files = e.target.files;
                                                                if (files.length > 0) {
                                                                    getBase64(files[0]);
                                                                }
                                                            }} id="dropzone-file" type="file" className="hidden" />
                                                        </label>
                                                    </div>}
                                            </div>
                                            <div className="sm:col-span-8 lg:col-span-7">

                                                <input onChange={(e) => setProductName(e.target.value)} placeholder='Enter Product Name' className='border-b-2 outline-none w-96 text-2xl focus:border-green-500' defaultValue={productName}></input>

                                                <section aria-labelledby="information-heading" className="mt-2">
                                                    <h3 id="information-heading" className="sr-only">
                                                        Product information
                                                    </h3>

                                                    ₹  <input onChange={(e) => setCost(e.target.value)} placeholder='Enter Price' className='border-b-2 outline-none w-60 mt-5 focus:border-green-500' defaultValue={cost}></input>



                                                </section>

                                                <section aria-labelledby="options-heading" className="mt-10">
                                                    <h3 id="options-heading" className="sr-only">
                                                        Product options
                                                    </h3>

                                                    <div>
                                                        <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">Description</h2>
                                                        <textarea defaultValue={description} onChange={(e) => setDescription(e.target.value)} placeholder='Enter Description' className='border-2 border-gray-200 outline-none w-full h-40 mt-5 focus:border-green-500 focus:ring-0 rounded-lg appearance-none'></textarea>

                                                        <div className='flex justify-between gap-3'>
                                                            <div className='flex space-x-3 items-center mt-5'>
                                                                <label>Quantity</label>
                                                                <input type="number" onChange={(e) => setQuantity(e.target.value)} className='block w-full appearance-none rounded-md border-b-2 border-gray-300  placeholder-gray-400 shadow-sm focus:border-green-500 focus:outline-none focus:ring-green-600 disabled:cursor-wait disabled:opacity-50 sm:text-sm' defaultValue={quantity}></input>
                                                            </div>
                                                            <div className='flex space-x-3 items-center mt-5'>
                                                                <label>Discount</label>
                                                                <input type='number' onChange={(e) => setDiscount(e.target.value)} className='block w-full appearance-none rounded-md border-b-2 border-gray-300  placeholder-gray-400 shadow-sm focus:border-green-500 focus:outline-none focus:ring-green-600 disabled:cursor-wait disabled:opacity-50 sm:text-sm' defaultValue={discount}
                                                                    placeholder="0-100"></input>
                                                            </div>
                                                        </div>
                                                        <div className='mt-5 justify-between flex'>
                                                            <div className='flex space-x-3  items-center'>
                                                                <label htmlFor="underline_select">Type</label>
                                                                <select defaultValue={type} onChange={(e) => setType(e.target.value)} id="underline_select" className="block w-26 text-sm bg-transparent border-0 border-b-2 border-gray-200 appearance-none  dark:border-green-700 focus:outline-none focus:ring-0 focus:border-green-500 peer">

                                                                    {TYPE.map(element => (
                                                                        <option key={element} value={element}>{element}</option>
                                                                    ))}

                                                                </select>
                                                            </div>
                                                            <div className='flex space-x-3  items-center'>
                                                                <label htmlFor="underline_select">Status</label>
                                                                <select defaultValue={status} onChange={(e) => setStatus(e.target.value)} id="underline_select" className="block text-sm bg-transparent border-0 border-b-2 border-gray-200 appearance-none  dark:border-green-700 focus:outline-none focus:ring-0 focus:border-green-500">

                                                                    {STATUS.map((element, index) => (
                                                                        <option key={index} value={element}>{element}</option>
                                                                    ))}

                                                                </select>
                                                            </div>
                                                        </div>
                                                        <h3 className='text-xl mt-5 tracking-tight text-gray-900 sm:text-2xl'>Features</h3>
                                                        <div className='mt-2 gap-5 flex'>
                                                            <input onChange={e => setFeatureFirst(e.target.value)} placeholder='Plant Type' id='planttype' className='border-b-2 outline-none w-full focus:border-green-500' defaultValue={featureFirst}></input>
                                                            <input onChange={e => setFeatureSecond(e.target.value)} placeholder='Soil Type' id='soiltype' className='border-b-2 outline-none w-full focus:border-green-500' defaultValue={featureSecond}></input>
                                                            <input onChange={e => setFeatureThird(e.target.value)} placeholder='Mature Size' id='maturesize' className='border-b-2 outline-none w-full focus:border-green-500' defaultValue={featureThird}></input>
                                                            <input onChange={e => setFeatureFourth(e.target.value)} placeholder='Family' id='family' className='border-b-2 outline-none w-full focus:border-green-500' defaultValue={featureFourth}></input>
                                                        </div>
                                                        <button
                                                            onClick={() => handleSubmit()}
                                                            className="mt-6 flex w-full items-center justify-center rounded-md border border-transparent bg-green-600 py-3 px-8 text-base font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2"
                                                        >
                                                            Add
                                                        </button>
                                                    </div>

                                                </section>
                                            </div>
                                        </div>

                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition.Root>

        </div>
    );
}

export default Inventory   